import toast from 'react-hot-toast';

// Toast IDs to prevent duplicates
const TOAST_IDS = {
  GOOGLE_LOGIN_SUCCESS: 'google-login-success',
  GOOGLE_LOGIN_ERROR: 'google-login-error',
  LOGOUT_SUCCESS: 'logout-success',
  LOGOUT_ERROR: 'logout-error',
  LOGIN_SUCCESS: 'login-success',
  LOGIN_ERROR: 'login-error',
  REGISTER_SUCCESS: 'register-success',
  REGISTER_ERROR: 'register-error',
  PROFILE_UPDATE_SUCCESS: 'profile-update-success',
  PROFILE_UPDATE_ERROR: 'profile-update-error',
};

export const showToast = {
  googleLoginSuccess: () => {
    toast.success('Logged in successfully with Google!', {
      id: TOAST_IDS.GOOGLE_LOGIN_SUCCESS,
      duration: 3000,
    });
  },
  
  googleLoginError: (message: string = 'Google authentication failed') => {
    toast.error(message, {
      id: TOAST_IDS.GOOGLE_LOGIN_ERROR,
      duration: 4000,
    });
  },
  
  loginSuccess: () => {
    toast.success('Logged in successfully!', {
      id: TOAST_IDS.LOGIN_SUCCESS,
      duration: 3000,
    });
  },
  
  loginError: (message: string = 'Login failed') => {
    toast.error(message, {
      id: TOAST_IDS.LOGIN_ERROR,
      duration: 4000,
    });
  },
  
  logoutSuccess: () => {
    toast.success('Logged out successfully!', {
      id: TOAST_IDS.LOGOUT_SUCCESS,
      duration: 3000,
    });
  },
  
  logoutError: () => {
    toast.error('Logout failed', {
      id: TOAST_IDS.LOGOUT_ERROR,
      duration: 4000,
    });
  },
  
  registerSuccess: () => {
    toast.success('Account created successfully!', {
      id: TOAST_IDS.REGISTER_SUCCESS,
      duration: 3000,
    });
  },
  
  registerError: (message: string = 'Registration failed') => {
    toast.error(message, {
      id: TOAST_IDS.REGISTER_ERROR,
      duration: 4000,
    });
  },
  
  profileUpdateSuccess: () => {
    toast.success('Profile updated successfully!', {
      id: TOAST_IDS.PROFILE_UPDATE_SUCCESS,
      duration: 3000,
    });
  },
  
  profileUpdateError: (message: string = 'Failed to update profile') => {
    toast.error(message, {
      id: TOAST_IDS.PROFILE_UPDATE_ERROR,
      duration: 4000,
    });
  },
};